import { render, staticRenderFns } from "./cookieConsent.vue?vue&type=template&id=6e226438"
import script from "./cookieConsent.vue?vue&type=script&lang=ts"
export * from "./cookieConsent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports